"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArtifactAutoAssignment = void 0;
var ArtifactAutoAssignment;
exports.ArtifactAutoAssignment = ArtifactAutoAssignment;
(function (ArtifactAutoAssignment) {
  ArtifactAutoAssignment["ENABLEAUTOASSIGNMENT"] = "enableAutoAssignment";
  ArtifactAutoAssignment["DISABLEAUTOASSIGNMENT"] = "disableAutoAssignment";
})(ArtifactAutoAssignment || (exports.ArtifactAutoAssignment = ArtifactAutoAssignment = {}));